import React from 'react';
import { StyledDiv, StyledSpan } from '../../../Theme/CommonStyled';
import { StyledCostSum, StyledCostSumContainer, StyledTable } from './style';
import { useTranslation } from 'react-i18next';
import { fixLocaleString } from '../../../Utils/common.util';
import useLandingStore from '../../../Store/Landing';

type InvoiceTableType = {
  columns: any;
  tableData: Record<string, any>[];
  textAlign?: string;
  headerStyles?: any;
  costSum?: string;
};

const InvoiceTable: React.FC<InvoiceTableType> = ({
  columns,
  tableData,
  textAlign,
  costSum
}) => {
  const { t } = useTranslation();

  const landingData = useLandingStore((state) => state.landingData);

  return (
    <>
      <StyledDiv
        pb={'14px'}
        borderBottom={costSum ? 0 : 'unset'}
        borderColor="border"
        direction="rtl">
        <StyledTable columns={columns} data={tableData} textAlign={textAlign} />
      </StyledDiv>
      {costSum && (
        <StyledCostSumContainer>
          <StyledDiv ml={8} color="secondaryText" fontSize={2}>
            {t('global.total')} :
          </StyledDiv>
          <StyledCostSum>
            <StyledSpan mr={4} fontSize="0.8rem">
              {landingData?.currency}
            </StyledSpan>
            {fixLocaleString(costSum)}
          </StyledCostSum>
        </StyledCostSumContainer>
      )}
    </>
  );
};

export default InvoiceTable;
